export default [
  {
    path: '/c8m/setting',
    name: 'C8mSetting',
    component: () => import('./Setting.vue'),
    meta: {title: 'C8M参数&模型'}
  },
]
